import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { APIHelper } from 'src/shared/services/api-helper/api-helper.service';
import { V2NODE_URL } from 'src/environments/environment';
import{ endpoints} from 'src/app/v2-node-api/common/api-endpoints';
import {DataService} from 'src/app/v2-node-api/services/data.service'

@Injectable({
  providedIn: 'root'
})
export class TwilioService  extends DataService {
    constructor(httpClient: HttpClient) {
      super(endpoints.twilio, httpClient);
    }


 
}
